(function(app) {

    app.provider("arcBusinessApi",
    [
        function() {
            this.$get = [
                "portalApiGateway", function (portalApiGateway) {
                    var service = {};

                    service.getAgentBrokerDealer = function() {
                        return portalApiGateway.get("/Users/Fig/Arc/Agent/Business");
                    };

                    //Agent Production TODO: Organize api calls
                    service.getAgentPremiumAmountByYear = function (productionYear) {
                        return portalApiGateway.get("/Agents/GetAgentPremiumAmount/" + productionYear);
                    };

                    service.getArcProducts = function () {
                        return portalApiGateway.get("/Arc/Products");
                    };

                    return service;
                }
            ];
        }
    ]);
})(window.app);